import template from './commonchangedtodrg.html';
import controller from './commonchangedtodrg.controller';
import './commonchangedtodrg.styl';

let commonchangedtodrgComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default commonchangedtodrgComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/commonchangedtodrg/commonchangedtodrg.component.js